import { Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

const BootstrapTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.arrow}`]: {
		color: '#616161E5',
	},
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: '#616161E5',
	},
}));

export default BootstrapTooltip;
